import React, {useEffect, useState} from "react";
import "./AddTeacherPage.sass";
import Window from "../../../_containers/window/Window";
import CircleButton from "../../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import {useNavigate} from "react-router";
import TextFieldEdit from "../../../_components/common/fields/TextFieldEdit";
import PhoneNumberTextEdit from "../../../_components/common/fields/PhoneNumberTextEdit";
import {useDispatch, useSelector} from "react-redux";
import {FAILED, IDLE, LOADING} from "../../../common/statuses";
import Spinner from "../../common/anonymous/Spinner";
import ButtonComponent from "../../../_components/common/buttons/ButtonComponent";
import {getCourses, saveTeacher} from "../../../_actions/auth/authAdminService";
import {Checkbox, FormControlLabel} from "@mui/material";
import {useSnackbar} from "notistack";
import _ from "lodash";

export default function AddTeacherPage() {
    const [username, setUsername] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState();
    const [birthDate, setBirthDate] = useState("");
    const [courses, setCourses] = useState({});

    const {error, saveStatus} = useSelector(state => state.auth.teacher);
    const {list: coursesList, status} = useSelector(state => state.auth.courses);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar()

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getCourses())
        }
        if (saveStatus === FAILED) {
            enqueueSnackbar("Произошла ошибка", {variant: "error"})
        }
    }, [status, saveStatus, dispatch])

    if (saveStatus === LOADING
        || status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    const handleSaveTeacher = () => {
        const request = {
            username, firstName, lastName,
            middleName: _.isEmpty(middleName) ? null : middleName,
            phoneNumber: phoneNumber && phoneNumber.match(/\d/g).join(""),
            birthDate,
            courses: Object.values(courses)
        }
        // console.log(courses)
        // console.log(Object.values(courses))
        // console.log(request);
        dispatch(saveTeacher(request))
    }

    const renderField = (Component, isRequired, label, value, setValue, error, props) => {
        return <Component required={isRequired}
                          {...props}
                          value={value}
                          error={error}
                          helperText={error}
                          onChange={e => setValue(e.target.value)}
                          label={label}/>
    }

    const renderCourse = (course, i) => {
        const handleChangeCourse = () => {
            let res;
            if (courses[i]) {
                res = {...courses};
                delete res[i];
            } else {
                res = {...courses};
                res[i] = {id: course.id};
            }
            setCourses(res);
        }

        return (
            <FormControlLabel key={`AddTeacherPage-checkbox-${i}`}
                              control={<Checkbox/>}
                              label={course.name}
                              checked={!!courses[i]}
                              onChange={handleChangeCourse}
                              labelPlacement="end"/>
        )
    }


    return <Window>
        <div className="AddTeacherPage-title">
            <div className="AddTeacherPage-title-text">Добавление учителя</div>
            <CircleButton onClick={() => navigate(-1)} Icon={CloseIcon}/>
        </div>
        <div className="AddTeacherPage-fields">
            {renderField(TextFieldEdit, true, "Эл. почта", username, setUsername, error && error.username)}
            {renderField(TextFieldEdit, true, "Имя", firstName, setFirstName, error && error.firstName)}
            {renderField(TextFieldEdit, true, "Фамилия", lastName, setLastName, error && error.lastName)}
            {renderField(TextFieldEdit, false, "Отчество", middleName, setMiddleName, error && error.middleName)}
            {renderField(PhoneNumberTextEdit, true, "Номер телефона", phoneNumber, setPhoneNumber, error && error.phoneNumber)}
            {renderField(TextFieldEdit, true, "День рождения", birthDate, setBirthDate, error && error.birthDate, {
                type: "date",
                InputLabelProps: {shrink: true}
            })}
            <fieldset>
                <legend>Курсы</legend>
                {coursesList.map(renderCourse)}
            </fieldset>
        </div>
        <div className="AddTeacherPage-button-panel">
            <ButtonComponent onClick={handleSaveTeacher}>Сохранить</ButtonComponent>
        </div>
    </Window>
}